export const DISCORD_INVITE = "https://discord.gg/T2nvHdP";
